<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="edit-room-type content-wrapper">
      <div class="page-header">{{ $t('editPromotionRemark') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'HotelRateCodeList' }">{{ $t('promotionList') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('editPromotionRemark') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="0">
        <div class="el-form-item el-form-item__content">
          <editor-component v-model="content"></editor-component>
        </div>
        <el-form-item>
          <el-button type="primary" @click="onUpdatePromotionRemarkButtonClick">{{ $t('edit') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </ContentContainer>
</template>

<script>
import { clone } from 'lodash'
import i18nMessages from '@/translations/Hotel/ManageHotel/Promotion/Remark.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import EditorComponent from '@/components/EditorComponent'
import RemarkApi from '@/api/hotel/remark-api'
import { REMARK_TYPE } from '@/configs/constant'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { getHotelIndexRoute } from '@/services/hotel-service'

export default {
  name: 'HotelPromotionRemark',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer, EditorComponent },
  i18n: { messages: i18nMessages },
  props: {
    hotelId: {
      type: String,
      default: ''
    },
    remarkContent: {
      type: String,
      default: ''
    }
  },
  created: async function () {
    this.isLoading = true

    if (this.hotelId === undefined || this.hotelId === '') {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    this.content = clone(this.remarkContent)
    this.isLoading = false
  },
  data () {
    return {
      content: '',
      isLoading: true
    }
  },
  methods: {
    onUpdatePromotionRemarkButtonClick: async function () {
      try {
        this.startLoading()

        const data = {
          content: this.content
        }
        await RemarkApi.update(this.hotelId, REMARK_TYPE.PROMOTION, data)
        const title = this.$t('editPromotionRemarkSuccessTitle')
        const message = this.$t('editPromotionRemarkSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
      this.$router.push({
        name: 'HotelPromotionList'
      })
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'HotelPromotionList'
      })
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
  .el-form-item__content {
    line-height: 22px;
  }
</style>
